<script>
export default {
  props: {
    isPreview: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    currentTraining() {
      return this.$store.state.trainings.current;
    },
    currentItemsFlatArray() {
      return this.$store.getters['trainings/currentItemsFlatArray'];
    },
    currentItemsFlatArrayCompleted() {
      return this.$store.getters['trainings/currentItemsFlatArrayCompleted'];
    },
    completedPercentage() {
      return this.$store.getters['trainings/completedPercentage'];
    },
  },
};
</script>

<template>
  <div
    v-if="currentTraining"
    class="box is-primary is-custom px-3 pb-4 pt-2 is-size-8"
  >
    <span class="is-block mb-1">
      {{ isPreview ? 0 : completedPercentage }}% {{ $t('completed') }}
    </span>
    <span class="is-relative is-block">
      <div
        class="
          is-flex is-justify-content-center is-align-items-center
          has-background-primary is-custom
          is-absolute zindex-10
        "
        style="
          width:28px;height:28px;
          top:0;right:0;border-radius:100%;
          transform:translate(0, -25%);
        "
      >
        <b-icon
          type="is-white"
          icon="trophy"
        />
      </div>
      <b-progress
        class="w-full"
        type="is-success"
        size="is-small"
        :value="currentItemsFlatArrayCompleted.length"
        :max="currentItemsFlatArray.length"
      />
    </span>
  </div>
</template>
